import styled from 'styled-components'
import Color from 'color'

export const NoticeWrapper = styled.div`
  border: 1px solid var(--Neutral-Gray300);
  border-left: 2px solid ${({ theme }) => theme.primaryColor};
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  padding: 24px;
  background: ${({ theme }) =>
    Color(theme.primaryColor).lightness(99).toString()};
  color: var(--Neutral-Gray600);

  strong {
    line-height: 20px;
    color: var(--Neutral-Gray800);
  }

  svg.icon {
    width: 20px;
    height: 20px;
    stroke: ${({ theme }) => theme.primaryColor};
  }
`

export const ButtonWrapper = styled.div`
  margin-left: 50px;
`
